var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-done-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M13.3333 7.3205V4.98716C13.3333 4.05374 13.3333 3.58703 13.1517 3.23051C12.9919 2.91691 12.7369 2.66194 12.4233 2.50215C12.0668 2.3205 11.6001 2.3205 10.6667 2.3205H4.33333C3.39991 2.3205 2.9332 2.3205 2.57668 2.50215C2.26308 2.66194 2.00811 2.91691 1.84832 3.23051C1.66667 3.58703 1.66667 4.05374 1.66667 4.98716V11.3205C1.66667 12.2539 1.66667 12.7206 1.84832 13.0771C2.00811 13.3908 2.26308 13.6457 2.57668 13.8055C2.9332 13.9872 3.39991 13.9872 4.33333 13.9872H6.66667M10 13.1538L11.6667 14.8205L15.4167 11.0705M9.33333 18.9872H15.6667C16.6001 18.9872 17.0668 18.9872 17.4233 18.8055C17.7369 18.6457 17.9919 18.3908 18.1517 18.0771C18.3333 17.7206 18.3333 17.2539 18.3333 16.3205V9.98716C18.3333 9.05374 18.3333 8.58703 18.1517 8.23051C17.9919 7.91691 17.7369 7.66194 17.4233 7.50215C17.0668 7.3205 16.6001 7.3205 15.6667 7.3205H9.33333C8.39991 7.3205 7.9332 7.3205 7.57668 7.50215C7.26308 7.66194 7.00811 7.91691 6.84832 8.23051C6.66667 8.58703 6.66667 9.05374 6.66667 9.98716V16.3205C6.66667 17.2539 6.66667 17.7206 6.84832 18.0771C7.00811 18.3908 7.26308 18.6457 7.57668 18.8055C7.9332 18.9872 8.39991 18.9872 9.33333 18.9872Z",
    stroke: "#676A73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionDefault);
export default __webpack_public_path__ + "static/media/actionDefault.32d2d8e8d19489324539f14572e00953.svg";
export { ForwardRef as ReactComponent };